export default __webpack_public_path__ + "static/media/psl.165df028.cjs";